type RefreshAccessToken = () => Promise<void>;

let refreshAccessToken: RefreshAccessToken | null = null;
let refreshPromise: Promise<void> | null = null;

export const OAUTH_STORAGE_KEY_PREFIX = "ROCP_";
export const OAUTH_ACCESS_TOKEN_STORAGE_KEY = `${OAUTH_STORAGE_KEY_PREFIX}token`;

export function setRefreshAccessToken(fn: RefreshAccessToken): void {
    refreshAccessToken = fn;
}

export async function refreshAccessTokenOnce(): Promise<void> {
    if (!refreshAccessToken) {
        throw new Error("Refresh access token function is not registered");
    }

    if (!refreshPromise) {
        refreshPromise = refreshAccessToken().finally(() => {
            refreshPromise = null;
        });
    }

    return refreshPromise;
}

export function getStoredAccessToken(): string | null {
    return localStorage.getItem(OAUTH_ACCESS_TOKEN_STORAGE_KEY);
}
